import { render, staticRenderFns } from "./OriBlog.vue?vue&type=template&id=20a9caad&scoped=true&"
import script from "./OriBlog.vue?vue&type=script&lang=js&"
export * from "./OriBlog.vue?vue&type=script&lang=js&"
import style0 from "./OriBlog.vue?vue&type=style&index=0&id=20a9caad&lang=scss&scoped=true&"
import style1 from "./OriBlog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9caad",
  null
  
)

export default component.exports